module.exports = __webpack_public_path__ + "static/media/sofort.f947f485.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sofort.png
// module id = 216
// module chunks = 0